import { execute } from './execute';

/**
 * The chronological activity feed: every purchase, sale and misc expense with a
 * date, an amount and a counterparty.
 *
 * Requires the History tile, and the server scopes it to the caller's own
 * records for roles that are restricted that way — so two people can see
 * different feeds, and each one's charts reconcile against the rows they can
 * actually open.
 *
 * Fetched once and reduced in the browser for every level of the dashboard's
 * drill-down. The alternative — a request per drill step — would be a round trip
 * for each click on data the client already holds.
 */
export function fetchActivity() {
  return execute('history.list');
}
